import React from 'react'
import { Card, Spinner } from 'react-bootstrap'
import moment from 'moment'

type RecentConversationUser = {
  id: number
  uuid: string
  name: string
  email: string
  phone_number: string
  last_conversation_at: string
}

interface OrganizationUsersCardProps {
  users: RecentConversationUser[]
  onSelectUser: (user: RecentConversationUser) => void
  selectedUser: RecentConversationUser | null
  loading: boolean
}

const OrganizationUsersCard: React.FC<OrganizationUsersCardProps> = ({
  users,
  onSelectUser,
  selectedUser,
  loading,
}) => {
  const formatTimeAgo = (dateString: string) => {
    return moment(dateString).calendar(null, {
      sameDay: '[today at] h:mm A',
      lastDay: '[yesterday at] h:mm A',
      lastWeek: 'dddd [at] h:mm A',
      sameElse: 'M/D/YY [at] h:mm A',
    })
  }

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2)
  }

  return (
    <Card
      className="mt-4"
      style={{
        height: 'clamp(400px, 70vh, 700px)',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '400px',
      }}
    >
      <Card.Header style={{ padding: 'clamp(12px, 3vw, 10px)' }}>
        <h3 className="mb-0" style={{ fontSize: 'clamp(18px, 4vw, 24px)' }}>
          Organization Users
        </h3>
      </Card.Header>
      <Card.Body
        className="flex-grow-1"
        style={{ overflowY: 'auto', padding: '0' }}
      >
        {loading ? (
          <div className="text-center p-4">
            <Spinner animation="border" />
            <p className="mt-2">Loading users...</p>
          </div>
        ) : users.length === 0 ? (
          <div className="text-center p-4">
            <p>No users with recent conversations found</p>
          </div>
        ) : (
          <div className="p-2">
            {users.map((user) => (
              <Card
                key={user.id}
                style={{
                  cursor: 'pointer',
                  border: 'none',
                  background:
                    selectedUser?.id === user.id ? '#454545' : 'transparent',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '0',
                }}
                onClick={() => onSelectUser(user)}
              >
                <Card.Body style={{ padding: 'clamp(8px, 2vw, 16px)' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div
                      className="d-flex align-items-center"
                      style={{ flex: 1, minWidth: 0 }}
                    >
                      <div
                        className="me-3 d-flex align-items-center justify-content-center"
                        style={{
                          flexShrink: 0,
                          width: 'clamp(40px, 12vw, 48px)',
                          height: 'clamp(40px, 12vw, 48px)',
                          backgroundColor: '#4EA6FF',
                          borderRadius: '50%',
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: 'clamp(14px, 3.5vw, 16px)',
                        }}
                      >
                        {getInitials(user.name)}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          className="fw-bold"
                          style={{ fontSize: 'clamp(14px, 4vw, 16px)' }}
                        >
                          {user.name}
                        </div>
                        <div
                          style={{
                            fontSize: 'clamp(11px, 2.5vw, 13px)',
                            color: '#999',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            width: '100%',
                          }}
                        >
                          {formatTimeAgo(user.last_conversation_at)}
                        </div>
                      </div>
                    </div>
                    <div className="ms-3">
                      <ion-icon
                        name="chevron-forward"
                        style={{
                          color: '#1DA1F2',
                          fontSize: 'clamp(16px, 4vw, 18px)',
                        }}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default OrganizationUsersCard
